import callApi from './callApi';

export const getAllProjectFromJIRA = async (showFiltered, projectId, searchQuery = '') => {
  const url = `jira/all-projects?${showFiltered ? 'showFiltered=true' : ''}${searchQuery ? `&searchQuery=${encodeURIComponent(searchQuery)}` : ''}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const getProjectReleaseVersions = async (linkedJiraId, projectId) => {
  const url = `jira/project/release-versions?id=${linkedJiraId}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const getProjectIssues = async (bodyData, projectId) => {
  const url = `jira/project-issues`;
  const headers = {
    'X-Project-Id': projectId,
  };
  let body = {
    ...bodyData,
  };
  return callApi(url, headers, 'POST', body);
};

export const getProjectIssuesCount = async (bodyData, projectId, jiraProject) => {
  const url = `jira/project-issues-count`;
  const headers = {
    'X-Project-Id': projectId,
  };
  let body = {
    bodyData,
    jiraProject,
  };
  return callApi(url, headers, 'POST', body);
};

export const getIssueTypes = async (id, projectId) => {
  const url = `jira/get-jira-issuetypes?projectId=${id}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const getIssuePriorities = async (id, projectId) => {
  const url = `jira/get-jira-priorities?projectId=${id}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const getJiraProjectsUsers = async (id, projectId, searchValue) => {
  const url = `jira/get-project-users?projectId=${id}${searchValue ? `&searchTerm=${searchValue}` : ''}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const getIssueMetadata = async (linked_project_id, issueTypeId, projectId) => {
  const url = `jira/issue-metadata?projectId=${linked_project_id}&issueTypeId=${issueTypeId}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const getJiraLabels = async (projectId) => {
  const url = `jira/labels`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const createJiraIssue = async (data, projectId) => {
  const url = `jira/create-issue`;
  const headers = {
    'Content-Type': 'application/json',
    'X-Project-Id': projectId,
  };
  let body = {
    ...data,
  };
  return callApi(url, headers, 'POST', body);
};

export const createIssueLinks = async (data, projectId) => {
  const url = `jira/create-issue-links`;
  const headers = {
    'Content-Type': 'application/json',
    'X-Project-Id': projectId,
  };
  let body = {
    ...data,
  };
  return callApi(url, headers, 'POST', body);
};



export const getTestCases = async (isArchived, page, perPage, searchValue, projectId, queryString) => {
  const url = `testcases?projectId=${projectId}&archive=${isArchived}&page=${page}&perPage=${perPage}&search=${searchValue || ''}${queryString ? `&${queryString}` : ''}`;
  const headers = {
  };
  return callApi(url, headers, 'GET');
};

export const getTestCase = async (testCaseKey, projectId) => {
  const url = `testcases/${testCaseKey}?projectId=${projectId}`;
  const headers = {
  };
  return callApi(url, headers, 'GET');
};

export const updateTestCases = async (payload, id) => {
  let url = `testcases/${id}`;
  let headers = {
  };
  let body = {
    ...payload,
  };
  return callApi(url, headers, 'PUT', body);
};

export const addTestCases = async (payload, projectId) => {
  const url = `testcases?projectId=${projectId}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    ...payload,
  };
  return await callApi(url, headers, 'POST', body);
};


export const deleteTestCase = async (id) => {
  const url = `testcases/${id}`;
  const headers = {
  };
  return callApi(url, headers, 'DELETE');
};

export const getJiraIssues = async (bodyData, projectId) => {
  const url = `jira/fetch-issues`;
  const headers = {
    'X-Project-Id': projectId,
  };
  let body = {
    ...bodyData,
  };
  return callApi(url, headers, 'POST', body);
};